import { render, staticRenderFns } from "./logoff.vue?vue&type=template&id=0c02f4f8&scoped=true"
import script from "./logoff.vue?vue&type=script&lang=js"
export * from "./logoff.vue?vue&type=script&lang=js"
import style0 from "./logoff.vue?vue&type=style&index=0&id=0c02f4f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c02f4f8",
  null
  
)

export default component.exports